const portfolioList = [
    {
        id: 1,
        kind: "work-item rim",
        toShop: "/shop",
        src: "./assets/images/gallerybeta/RimSeriesCom/JR 25 960480.png",
        alt: "JR 25 Rims",
        title: "JR 25 Rims",
    },
    {
        id: 2,
        kind: "work-item part",
        toShop: "/shop",
        src: "assets/images/gallerybeta/PartsCom/Exhausts.jpeg",
        alt: "Exhausts",
        title: "Exhausts",
    },
    {
        id: 3,
        kind: "work-item rim",
        toShop: "/shop",
        src: "assets/images/gallerybeta/RimSeriesCom/Hyperblack 900860.png",
        alt: "Hyperblack Rims",
        title: "Hyperblack Rims",
    },
    {
        id: 4,
        kind: "work-item light",
        toShop: "/shop",
        src: "assets/images/gallerybeta/LightsSeriesCom/Tail headlights 1000680-2.png",
        alt: "Tail headlights",
        title: "Tail headlights",
    },
    {
        id: 5,
        kind: "work-item part",
        toShop: "/shop",
        src: "assets/images/gallerybeta/PartsCom/Alternators 1000680.png",
        alt: "Alternators",
        title: "Alternators",
    },
    {
        id: 6,
        kind: "work-item service",
        toShop: "/shop",
        src: "assets/images/gallerybeta/ServicesCom/Timing belt (1).png",
        alt: "Timing Belt",
        title: "Timing Belt",
    },
    {
        id: 7,
        kind: "work-item rim",
        toShop: "/shop",
        src: "assets/images/gallerybeta/RimSeriesCom/Bronze 960960.png",
        alt: "Bronze Rims",
        title: "Bronze Rims",
    },
    {
        id: 8,
        kind: "work-item light",
        toShop: "/shop",
        src: "assets/images/gallerybeta/LightsSeriesCom/HID Headlights 900430-2.png",
        alt: "HID headlights",
        title: "HID headlights",
    },
    {
        id: 9,
        kind: "work-item rim",
        toShop: "/shop",
        src: "assets/images/gallerybeta/RimSeriesCom/Aluminum 400300.png",
        alt: "Aluminum Rims",
        title: "Aluminum Rims",
    },
    {
        id: 10,
        kind: "work-item service",
        toShop: "/shop",
        src: "assets/images/gallerybeta/ServicesCom/Oil changing 900860.png",
        alt: "Oil services",
        title: "Oil services",
    },
    {
        id: 11,
        kind: "work-item rim",
        toShop: "/shop",
        src: "assets/images/gallerybeta/RimSeriesCom/JRwheels 940567.png",
        alt: "JRwheels Rims",
        title: "JRwheels Rims",
    },
    {
        id: 12,
        kind: "work-item light",
        toShop: "/shop",
        src: "assets/images/gallerybeta/LightsSeriesCom/day-time driving lights 600400-2.png",
        alt: "day-time driving lights",
        title: "day-time driving lights",
    },
    {
        id: 13,
        kind: "work-item light",
        toShop: "/shop",
        src: "assets/images/gallerybeta/LightsSeriesCom/Fog lights.webp",
        alt: "Fog lights",
        title: "Fog lights",
    },
    {
        id: 14,
        kind: "work-item service",
        toShop: "/shop",
        src: "assets/images/gallerybeta/ServicesCom/Spark plugs Services.jpeg",
        alt: "Spark Plugs",
        title: "Spark Plugs",
    },
    {
        id: 15,
        kind: "work-item light",
        toShop: "/shop",
        src: "assets/images/gallerybeta/LightsSeriesCom/Halogen headlights 400500-2.png",
        alt: "Halogen headlights",
        title: "Halogen headlights",
    },
    {
        id: 16,
        kind: "work-item service",
        toShop: "/shop",
        src: "assets/images/gallerybeta/ServicesCom/Engine repairing 960960.png",
        alt: "Engine repairing",
        title: "Engine repairing",
    },
    {
        id: 17,
        kind: "work-item rim",
        toShop: "/shop",
        src: "assets/images/gallerybeta/RimSeriesCom/JR Brones 450430.png",
        alt: "JR Brones Rims",
        title: "JR Brones Rims",
    },
    {
        id: 18,
        kind: "work-item light",
        toShop: "/shop",
        src: "assets/images/gallerybeta/LightsSeriesCom/LED Headlights 960480-2.png",
        alt: "LED headlights",
        title: "LED headlights",
    },
    {
        id: 19,
        kind: "work-item part",
        toShop: "/shop",
        src: "assets/images/gallerybeta/PartsCom/Battery 900430.png",
        alt: "Battery",
        title: "Battery",
    },
    {
        id: 20,
        kind: "work-item part",
        toShop: "/shop",
        src: "assets/images/gallerybeta/PartsCom/Brake pads 940567.png",
        alt: "Brake pads",
        title: "Brake pads",
    },
];

export const PortfolioList = portfolioList.map((p) => ({
    ...p,
    description: p.title,
}));
